import { ReactElement } from 'react'
import BaseLayout from 'src/v3/components/base-layout'
import {
  DashboardIcon,
  LinkedServiceIcon,
  LiveClassIcon,
  SpecialCertificationIcon,
  TemplateIcon,
  UserIcon,
} from '../core/icons'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => <BaseLayout
  children={children}
  domain='admin'
  role='admin'
  subMenuItems={[
    { name: 'Dashboard', route: '/', icon: <DashboardIcon /> },
    { name: 'Users', route: '/users', icon: <UserIcon /> },
    { name: 'Linked Services', route: '/linked-services', icon: <LinkedServiceIcon /> },
    { name: 'Live Classes', route: '/live', icon: <LiveClassIcon /> },
    { name: 'Templates', route: '/live/templates', subMenu: true, icon: <TemplateIcon /> },
    { name: 'Special Certifications', route: '/special-certifications', icon: <SpecialCertificationIcon /> },
  ]}
/>
